import { render, staticRenderFns } from "./centralizedDeptManagement.vue?vue&type=template&id=0dfb6242&scoped=true&"
import script from "./centralizedDeptManagement.vue?vue&type=script&lang=js&"
export * from "./centralizedDeptManagement.vue?vue&type=script&lang=js&"
import style0 from "./centralizedDeptManagement.vue?vue&type=style&index=0&id=0dfb6242&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfb6242",
  null
  
)

export default component.exports